"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _section = require("@nucleo/section");
function cov_2egw9wid5h() {
  var path = "/codebuild/output/src1689451169/src/git-codecommit.eu-central-1.amazonaws.com/v1/repos/gravity/apps/tnwi/temp/nucleo/calendar/lib/type.js";
  var hash = "46004971fd5ea26f8b6fa23cfb2456dc88cba885";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src1689451169/src/git-codecommit.eu-central-1.amazonaws.com/v1/repos/gravity/apps/tnwi/temp/nucleo/calendar/lib/type.js",
    statementMap: {
      "0": {
        start: {
          line: 4,
          column: 21
        },
        end: {
          line: 9,
          column: 2
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "46004971fd5ea26f8b6fa23cfb2456dc88cba885"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2egw9wid5h = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_2egw9wid5h();
var CalendarType = (cov_2egw9wid5h().s[0]++, _propTypes.default.shape({
  // contains a map of section month to section containing all month days : {'YYYY-MM' :
  sectionByMonth: _propTypes.default.objectOf(_section.SectionType),
  // it is a shape of year containing a list of month. All are numbers (XXXX : [0->11])
  months: _propTypes.default.objectOf(_propTypes.default.arrayOf(_propTypes.default.number))
}));
var _default = exports.default = CalendarType;